export const geotag_categories: { [id: string]: string; } =
{
  "Geology":   "brown",
  "Information": "lightblue",
  "Navigation": "blue",
  "Object": "red",
  "Diving":  "yellow",
  "Sample":  "green",
  "Design/Dredging": "violet",
  "Sound Velocity Profile": "lightgreen"
}
;
